export const OPENCAGE_API_KEY = 'ee07a136d1dd45edab5b06534e84ef8b';
export const OPENWEATHERMAP_ICON_URL_PREFIX = 'https://openweathermap.org/img/wn/';
export const W2W_BUTTON_TEXT = 'what 2 wear';
export const BASE_URL = '/what2wear';

export const COMFORT = 75;
